import { actions } from '../../../state/status';
import AlertDownload from '../../elements/AlertDownload';
import { connect } from 'react-redux';
import { actions as authactions } from '../../../state/auth';
import { actions as assessmentactions } from '../../../state/assessment';
import { actions as statusactions } from '../../../state/status';
import { getStore, getPersistor } from '../../../index.js';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  isOpen: state.shift.status.error
});

const mapDispatchToProps = (dispatch, ownProps) =>
   ({
      onClose: value => {
        dispatch(authactions.logout())
          .then(dispatch(()=>{
            localStorage.clear();
            sessionStorage.clear();
            assessmentactions.resetAssessmentStore();
            statusactions.resetStatus();
            window.location.reload();
          }));
    }
  })
;

const AlertDownloadComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertDownload);

export default AlertDownloadComponent;



// WEBPACK FOOTER //
// ./src/components/container/AlertDownload/index.js